import React from 'react';

export default function Footer() {
    return (
        <footer>
            <div className="container-fluid">
                <span>© Copyright 2023 | Quản Lý Sinh Viên</span>
            </div>
            <a href="!#" className="back-to-top">
                <i className="fa-solid fa-angle-up" />
            </a>
        </footer>

    );
}